/* Ajoute / retire automatiquement le cadeau selon le nombre d'articles éligibles. */
(function () {
  if (window.__cartGiftSync) return;
  window.__cartGiftSync = true;
  var cfg = window.cartGiftConfig;
  if (!cfg || !cfg.variantId) return;

  var origFetch = window.fetch.bind(window);
  var busy = false, timer = null;

  function schedule() { clearTimeout(timer); timer = setTimeout(sync, 250); }

  function render(sections) {
    if (!sections) return;
    var parser = new DOMParser();
    if (sections['cart-drawer']) {
      var doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
      var ni = doc.querySelector('.drawer__inner');
      var oi = document.querySelector('cart-drawer .drawer__inner');
      if (ni && oi) oi.innerHTML = ni.innerHTML;
    }
    if (sections['cart-icon-bubble']) {
      var doc2 = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
      var s = doc2.querySelector('.shopify-section');
      var el = document.getElementById('cart-icon-bubble');
      if (s && el) el.innerHTML = s.innerHTML;
    }
  }

  async function sync() {
    if (busy) return;
    busy = true;
    try {
      var cart = await (await origFetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
      var eligible = 0, gift = 0;
      cart.items.forEach(function (i) {
        if (i.variant_id == cfg.variantId) gift += i.quantity;
        else if ((i.product_type || '') !== cfg.type) eligible += i.quantity;
      });
      var want = eligible >= cfg.min ? 1 : 0;
      if (gift !== want) {
        var updates = {}; updates[cfg.variantId] = want;
        var res = await origFetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates, sections: ['cart-drawer', 'cart-icon-bubble'] })
        });
        var data = await res.json();
        if (/^\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
        render(data.sections);
      }
    } catch (e) { /* silencieux */ }
    busy = false;
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch(input, init);
    if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(schedule, function () {});
    return p;
  };
  if (window.jQuery) {
    window.jQuery(document).ajaxComplete(function (e, xhr, opts) {
      if (opts && /\/cart\/(add|change|update|clear)/.test(opts.url || '')) schedule();
    });
  }

  // Compte à rebours jusqu'à minuit (heure de Paris) dans le panier
  var fmt = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Paris', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
  function pad(n) { return String(n).padStart(2, '0'); }
  setInterval(function () {
    var els = document.querySelectorAll('[data-cof-countdown]');
    if (!els.length) return;
    var p = {}; fmt.formatToParts(new Date()).forEach(function (x) { p[x.type] = +x.value; });
    var r = 86400 - (p.hour * 3600 + p.minute * 60 + p.second);
    var txt = Math.floor(r / 3600) + 'h ' + pad(Math.floor(r / 60) % 60) + 'm ' + pad(r % 60) + 's';
    els.forEach(function (el) { el.textContent = txt; });
  }, 1000);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();
})();
